import { createSelector } from '@ngrx/store';
import { JobDetailsState } from 'src/app/recruiting/jobs/details/components/store/reducers/job-details.reducers';
import { JobState } from 'src/app/recruiting/jobs/details/components/store/state/job-details.state';
import { selectFeature as recturingFeature } from 'src/app/recruiting/store/recruiting.selectors';

export const jobDetailsLoaded = createSelector(
    recturingFeature,
    (state: JobState): JobDetailsState => state.jobDetailsState
);
